var a11y = require("./a11y");
function PDFCanvas(width, height, alt, drawFunc) {
    this.width = width || "auto";
    this.height = height || 0;
    if (typeof alt === "function") {
        drawFunc = alt;
        alt = "";
    }
    this.alt = alt;
    this.drawFunc = drawFunc;
    // TODO: validate the inputs
}
PDFCanvas.prototype.calc = function (cursor) {
    return {
        width: this.width === "auto" ? cursor.width : this.width,
        height: this.height,
    };
};
PDFCanvas.prototype.draw = function (cursor) {
    var canvasCursor = {
        x: cursor.x,
        y: cursor.y,
        width: this.width === "auto" ? cursor.width : this.width,
        height: this.height,
        doc: cursor.doc,
    };
    if (this.alt) {
        a11y.structure(cursor, "img", {
            alt: this.alt,
            attr: {
                O: "/Layout",
                BBox: cursor.doc.convertBBox(canvasCursor.x, canvasCursor.y, canvasCursor.width, canvasCursor.height),
            },
        }, function () {
            a11y.marked(cursor, function () {
                this.drawFunc.call(this, cursor.doc, canvasCursor);
            }, null, this);
        }, this);
    }
    else {
        this.drawFunc.call(this, cursor.doc, canvasCursor);
    }
    return {
        width: this.width === "auto" ? cursor.width : this.width,
        height: this.height,
    };
};
module.exports = PDFCanvas;
//# sourceMappingURL=module.js.map